import { createContext, useState } from "react";
import ContactIcon from "@assets/svg/ContactIcon";
import EducationIcon from "@assets/svg/EducationIcon";
import ExperienceIcon from "@assets/svg/ExperienceIcon";
import AboutIcon from "@assets/svg/AboutIcon";
import SkillsIconn from "@assets/svg/SkillsIconn";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";

export const ProfileProgressContext = createContext(null);

const CreateProfileProvider = ({ children }) => {
  const user = useSelector((state:RootState)=>state.auth.user);
  // const candidateDetails = useSelector((state:RootState)=>state.auth.user);
  
  const [tabs, setTabs] = useState([
    {
      label: "About",
      value: "about",
      isCompleted: true,
      subHeading: "Tell us who you are",
      description:
        "A clear summary helps recruiters understand your story in seconds — profiles with a strong intro get 3x more matches.",
      icon: <AboutIcon color="white" />,
    },
    {
      label: "Work Experience",
      value: "experience",
      isCompleted: true,
      subHeading: "Showcase your journey",
      description:
        "Add your roles and achievements so we can match you with jobs that align with your career path.",
      icon: <ExperienceIcon color="white" />,
    },
    {
      label: "Skills",
      value: "skills",
      isCompleted: true,
      subHeading: "Highlight what you're great at",
      description:
        "Your skills are the #1 signal we use to recommend jobs. The more you add, the sharper your matches.",
      icon: <SkillsIconn color="white" />,
    },
    {
      label: "Education & Certifications",
      value: "education",
      isCompleted: false,
      subHeading: "Back it up with credentials",
      description:
        "Degrees and certifications help unlock roles with specific qualification requirements.",
      icon: <EducationIcon color="white" />,
    },
    {
      label: "Contact Details",
      value: "contact",
      isCompleted: false,
      subHeading: "Stay reachable",
      description:
        "Recruiters need a reliable way to reach you when the right opportunity comes up.",
      icon: <ContactIcon color="white" />,
    },
  ]);

  const [activeTab, setActiveTab] = useState("about");

  return (
    <ProfileProgressContext.Provider
      value={{
        tabs,
        setTabs,
        activeTab,
        setActiveTab,
      }}
    >
      {children}
    </ProfileProgressContext.Provider>
  );
};

export default CreateProfileProvider;
